/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ProductWithNetSalesAndQuantity } from './ProductWithNetSalesAndQuantity';
import {
    ProductWithNetSalesAndQuantityFromJSON,
    ProductWithNetSalesAndQuantityFromJSONTyped,
    ProductWithNetSalesAndQuantityToJSON,
    ProductWithNetSalesAndQuantityToJSONTyped,
} from './ProductWithNetSalesAndQuantity';

/**
 * 
 * @export
 * @interface MenuMixBranchProductsWithNetSalesAndQuantityListResponse
 */
export interface MenuMixBranchProductsWithNetSalesAndQuantityListResponse {
    /**
     * 
     * @type {Array<ProductWithNetSalesAndQuantity>}
     * @memberof MenuMixBranchProductsWithNetSalesAndQuantityListResponse
     */
    data: Array<ProductWithNetSalesAndQuantity>;
    /**
     * 
     * @type {Pagination}
     * @memberof MenuMixBranchProductsWithNetSalesAndQuantityListResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the MenuMixBranchProductsWithNetSalesAndQuantityListResponse interface.
 */
export function instanceOfMenuMixBranchProductsWithNetSalesAndQuantityListResponse(value: object): value is MenuMixBranchProductsWithNetSalesAndQuantityListResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function MenuMixBranchProductsWithNetSalesAndQuantityListResponseFromJSON(json: any): MenuMixBranchProductsWithNetSalesAndQuantityListResponse {
    return MenuMixBranchProductsWithNetSalesAndQuantityListResponseFromJSONTyped(json, false);
}

export function MenuMixBranchProductsWithNetSalesAndQuantityListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuMixBranchProductsWithNetSalesAndQuantityListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ProductWithNetSalesAndQuantityFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

export function MenuMixBranchProductsWithNetSalesAndQuantityListResponseToJSON(json: any): MenuMixBranchProductsWithNetSalesAndQuantityListResponse {
    return MenuMixBranchProductsWithNetSalesAndQuantityListResponseToJSONTyped(json, false);
}

export function MenuMixBranchProductsWithNetSalesAndQuantityListResponseToJSONTyped(value?: MenuMixBranchProductsWithNetSalesAndQuantityListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ProductWithNetSalesAndQuantityToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

